import { Grid } from "@mui/material";
import React, { Fragment } from "react";
import { Input } from "../../../../controls";
import SectionLabel from "./SectionLabel";

const VariantInventoryFields = ({ setValues, variant }) => {
  const handleInpChg = (e, outletId) => {
    const { name, value } = e.target;

    // For the variant product
    if (variant)
      setValues((j) => ({
        ...j,
        prodVariants: [
          ...j.prodVariants.map((v) =>
            v.key === variant.key
              ? {
                  ...v,
                  inventories: [
                    ...v.inventories.map((i) =>
                      i.outletId === outletId ? { ...i, [name]: value } : i
                    ),
                  ],
                }
              : v
          ),
        ],
      }));
  };

  return (
    <>
      <Grid item xs={12}>
        <SectionLabel label="Inventory levels" />
      </Grid>

      {variant.inventories.map((inv, index) => {
        return (
          <Fragment key={index}>
            {variant.inventories.length > 1 && (
              <Grid item xs={12} md={2} className="flex items-center">
                <span className="text-[18px] text-gray-500 lg:pl-5">
                  {inv.outletName} :
                </span>
              </Grid>
            )}
            <Grid item xs={12} md={3.33}>
              <Input
                label="Current Inventory"
                name="inInv"
                value={inv.inInv}
                type="number"
                onChange={(e) => handleInpChg(e, inv.outletId)}
                size="small"
                disabled={variant.id ? true : false}
              />
            </Grid>
            <Grid item xs={12} md={3.33}>
              <Input
                label="Re-Order Point"
                name="reOrderPoint"
                value={inv.reOrderPoint}
                type="number"
                onChange={(e) => handleInpChg(e, inv.outletId)}
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={3.33}>
              <Input
                label="Re-Order Quantity"
                name="reOrderQty"
                value={inv.reOrderQty}
                type="number"
                onChange={(e) => handleInpChg(e, inv.outletId)}
                size="small"
              />
            </Grid>
          </Fragment>
        );
      })}
    </>
  );
};

export default VariantInventoryFields;
